import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import SendIcon from '@mui/icons-material/Send';
import RemoveIcon from '@mui/icons-material/Remove';
import dayjs from 'dayjs';
import { STATUS_META } from './whatsapp-status.constants';
import {
  WhatsappButtonWrap,
  WhatsappBadgeCircle,
} from 'modules/requests/pages/consultant-requests/style';
import { brand } from 'themes/brand';

type Props = {
  label: string;
  status?: string | null;
  updatedAt?: string | null;
  isSending: boolean;
  isDisabled: boolean;
  onClick: () => void;
};

export function WhatsappSendButton({
  label,
  status,
  updatedAt,
  isSending,
  isDisabled,
  onClick,
}: Props) {
  const metaKey = isSending ? 'SENDING' : status ?? null;
  const meta = metaKey ? STATUS_META[metaKey] ?? null : null;
  const isNone = !meta;
  const formattedDate = updatedAt
    ? dayjs(updatedAt).format('DD/MM HH:mm')
    : null;

  const tooltipContent = (
    <div>
      <div style={{ fontWeight: 600, fontSize: '0.75rem', marginBottom: 1 }}>
        {label}
      </div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 5,
          fontSize: '0.7rem',
          color: '#cbd5e1',
        }}
      >
        <span
          style={{
            display: 'inline-block',
            width: 6,
            height: 6,
            borderRadius: '50%',
            flexShrink: 0,
            background: meta ? meta.color : '#9ca3af',
          }}
        />
        {meta ? meta.label : 'Sem mensagem disparada'}
        {formattedDate && <span>· {formattedDate}</span>}
      </div>
    </div>
  );

  return (
    <Tooltip
      title={tooltipContent}
      placement="top"
      componentsProps={{
        tooltip: { sx: { bgcolor: brand.navy } },
        arrow: { sx: { color: brand.navy } },
      }}
    >
      <WhatsappButtonWrap
        isNone={isNone}
        onClick={onClick}
        disabled={isDisabled || isSending}
      >
        <SendIcon className="send-icon" />
        {label}
        <WhatsappBadgeCircle color={meta ? meta.color : '#9ca3af'}>
          {meta ? (
            <meta.Icon style={{ width: 10, height: 10, color: meta.color }} />
          ) : (
            <RemoveIcon style={{ width: 10, height: 10, color: '#9ca3af' }} />
          )}
        </WhatsappBadgeCircle>
      </WhatsappButtonWrap>
    </Tooltip>
  );
}
